export default "__VITE_ASSET__D4NynIl3__"